import './chartHelpers'
import { ExternalDashboardCardGrid } from '../../reusable/ui/ExternalDashboardCardGrid/ExternalDashboardCardGrid'
import { ClientSearchSection } from './sections/clientSearchSection'
import { FundingSection } from './sections/fundingSection'
import { LegacyStatsButton } from './sections/legacyStatsButton'
import { PCPIntroducersSection } from './sections/pcpIntroducersSection'
import { ReportLinksSection } from './sections/reportLinksSection'
import styles from './styles.module.scss'

export const HomeView = () => {
    return (
        <div className={styles.homeView}>
            <div className={styles.grid}>
                <PCPIntroducersSection />
                <ClientSearchSection />
                <FundingSection />
                <ReportLinksSection />
                <ExternalDashboardCardGrid />
            </div>
            <div className={styles.legacyFooter}>
                <LegacyStatsButton />
            </div>
        </div>
    )
}

export default HomeView
